import React from "react";
import Keyword from "../typography/Keyword";
import { TitleHeading } from "../typography/TitleHeading";
import SideImage from "../layout/SideImage";
import { useAnimation } from "../../hooks/useAnimate";

interface ImageFeaturesGrid4Props {
  tag: string;
  title: string | React.ReactNode;
  elements: {
    name: string;
    description: string;
  }[];
  image: string;
}

export const ImageFeaturesGrid4: React.FunctionComponent<
  ImageFeaturesGrid4Props
> = ({ tag, title, elements, image }) => {
  const { id, animate } = useAnimation();

  return (
    <SideImage theme="dark" image={image} imagePosition="object-top" id={id}>
      <div {...animate("fade-down")}>
        <TitleHeading theme="dark" tag={tag} title={title} />
      </div>
      <div className="grid md:grid-cols-2 gap-12 mt-16">
        {elements.map((element, i) => (
          <div {...animate("fade-left", 50 * i)} key={i}>
            <Keyword
              dark
              title={element.name}
              description={element.description}
              noMargin
            />
          </div>
        ))}
      </div>
    </SideImage>
  );
};
